import store from '../store'

export function getPermissionsByDeviceId(deviceId) {
  return store.getters['devices/getPermissionsByDeviceId'](deviceId)
}
